import { isImmutable } from "immutable";

export function convertStringArrayToUsableOptionsForCheckbox(values) {
	if (isImmutable(values)) {
		values = values.toJS();
	}

	const options = values ? values.map((value) => ({ value })) : [];

	return options;
}
